<template>
  <div
    @keyup.esc="localValue = false"
    @click="localValue = false"
    ref="modal"
    :class="`modal ${localValue ? '' : 'hidden'}`"
  >
    <div ref="content" class="content row justify-start overflow-hidden">
      <div class="card-preview column justify-evenly items-center">
        <div v-if="canNavigate"></div>
        <div @click.stop="() => {}">
          <DCard
            :key="cardKey"
            ref="dcard"
            v-if="content"
            :layout="layout"
            :showsActionOverlay="false"
            :content="content"
            :apiBaseUrl="apiBaseUrl"
          />
        </div>
        <div
          v-if="canNavigate"
          class="row justify-evenly full-width"
          style="height: 40px"
        >
          <q-btn
            @click="enterSection"
            class="q-pr-sm"
            color="secondary"
            no-caps
            dense
            icon="north_east"
            label="Enter Section"
          />
        </div>
        <div
          v-if="!content || !content.info"
          style="position: absolute; top: 10px; right: 10px"
          @click.stop="() => {}"
        >
          <q-btn
            @click="localValue = false"
            flat
            round
            dense
            icon="close"
            size="md"
          />
        </div>
      </div>
      <div class="card-info col q-py-sm" @click.stop="() => {}">
        <q-toolbar style="min-height: 40px">
          <q-icon name="info" size="sm" color="grey-9" />
          <div class="q-pl-md">INFORMATION</div>
          <q-space />
          <q-btn
            @click="localValue = false"
            flat
            icon="close"
            size="md"
            round
            dense
          />
        </q-toolbar>
        <q-scroll-area
          ref="preview-info-scroll-area"
          style="height: calc(640px - 89px)"
          class="q-pl-lg q-pr-md q-pt-md"
        >
          <DCardInfo
            v-if="content"
            :reset="!localValue"
            :info="content.info"
            :components="content.components"
            :parentMetas="parentMetas"
          />
        </q-scroll-area>
      </div>
    </div>
  </div>
</template>

<script>
import { uid } from "quasar";
import DCard from "./DCard.vue";
import DCardInfo from "../DCardInfo/DCardInfo.vue";
export default {
  name: "DCardPreview",
  components: { DCard, DCardInfo },
  props: {
    value: false,
    content: {
      type: Object,
      default: null,
    },
    layout: {
      type: Object,
      default: null,
    },
    allowCardNavigation: {
      type: Boolean,
      default: true,
    },
    apiBaseUrl: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      cardKey: null,
    };
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(val) {
        if (!val && this.$refs.dcard) {
          this.$refs.dcard.hideOverlayComponent();
        }
        this.$emit("input", val);
      },
    },
    canNavigate: {
      get() {
        return (
          this.allowCardNavigation &&
          this.content?.meta?.navigation !== undefined
        );
      },
    },
    parentMetas: {
      get() {
        return this.content.parentMetas;
      },
    },
    cid: {
      get() {
        if (this.content?.cid) {
          return this.content.cid;
        }

        return this.content?.client_id ?? "";
      },
    },
  },
  mounted() {
    this.rearrangeLayout();
  },
  updated() {
    this.rearrangeLayout();
  },
  watch: {
    localValue(val) {
      if (!val) {
        this.$refs["preview-info-scroll-area"].setScrollPosition("vertical", 0);
      }
      const body = document.querySelector("body");
      if (this.show === false && body.style.overflow === "hidden") {
        body.style.overflow = "";
        window.removeEventListener("keyup", this.onEscapeKeyUp);
      } else {
        this.cardKey = uid();
        body.style.overflow = "hidden";
        window.addEventListener("keyup", this.onEscapeKeyUp);
      }
    },
  },
  methods: {
    rearrangeLayout() {
      this.$refs.content.style.width = this?.content?.info ? "854px" : "400px";
      this.$refs.content.style.height = this.canNavigate ? "660px" : "600px";
      const content = getComputedStyle(this.$refs.content);
      const modalStyle = getComputedStyle(this.$refs.modal);

      this.$refs.content.style.left = `calc((${modalStyle.width} - ${content.width}) / 2)`;
      this.$refs.content.style.top = `calc((${modalStyle.height} - ${content.height}) / 2)`;
    },
    onEscapeKeyUp(event) {
      if (event.which === 27) {
        this.localValue = false;
      }
    },
    enterSection() {
      this.$emit("enterSection", this.content);
    },
  },
};
</script>

<style scoped>
.modal {
  position: absolute; /* Stay in place */
  z-index: 1; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background: rgba(0, 0, 0, 0.2);
  z-index: 1000;
}
.content {
  position: absolute;
  background: white;
  height: 640px;
  box-shadow: 0px 4px 64px rgba(0, 0, 0, 0.5);
}
.card-preview {
  background: #eee;
  width: 400px;
  height: 100%;
}
</style>
